<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form data-vv-scope="add-new-user">
        <vx-card :title="$t('AddUser') |ToUppercase">
          <UserComponent :user="user" :passReq="'required'" vvFormScope="add-new-user" addNew="true"></UserComponent>
          <div class="vx-row">
            <div class="vx-col w-full mt-base">
              <vs-button @click="submitForm" class="mr-3 mb-2">{{$t('Add') |ToUppercase}}</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import UserComponent from "../components/User";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    UserComponent
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  data: function() {
    return {
        user: {
          id: 0,
          firstname: "",
          lastname: "",
	        username: "",
	        password: "",
	        repeatPassword: "",
        }
    };
  },
  methods: {
    createJsonObject() {
      let payload = {
        Id: this.user.id,
        Firstname: this.user.firstname,
        Lastname: this.user.lastname,
        Username: this.user.username,
        Password: this.user.password,
        RepeatPassword: this.user.repeatPassword,
      };
      console.log(payload);
      return payload;
    },
    async submitForm() {
      let isFormValid = await this.$validator.validateAll("add-new-user");
      console.log(isFormValid);
      if (!isFormValid) return;

      this.$vs.loading();

      try {
        let payload = this.createJsonObject();

        let response = await this.$store.dispatch(
          "admin/addUser",
          payload
        );

        if (response.status == 200) {
          this.$vs.notify({
            text: this.$t("SuccessfullyAdded"),
            color: "success",
            iconPack: "feather",
            icon: "icon-check-circle"
          });
          this.$router.push(`/user/${response.data}`);
        }
      } catch (error) {
        this.$vs.notify({
          title: this.$t("Error"),
          text: error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    }
  }
};
</script>